import State, { Status } from "./model";
import Die from "./die";
import Face, { VpFace } from "./face";
import { PIP_1, PIP_2, PIP_3, PIP_4, PIP_5, PIP_6, VP_1, VP_2, X } from "./faces";
import { List } from "immutable";
import * as Actions from "./actions";
import * as Selector from "./selector";

const initialDie: Die = {
    faces: List<Face>([ PIP_1, PIP_2, PIP_3, PIP_4, PIP_5, PIP_6 ])
};

const initialState: State = {
    dice: List<Die>([ initialDie, initialDie, initialDie, initialDie, initialDie ]),
    currentRoll: undefined,
    selectedSeven: undefined,
    status: "BEGIN"
}

export default (state = initialState, action: Actions.AppAction ): State => {
    switch(action.type) {
        case Actions.NEW_GAME_ACTION:
            return initialState;
        case Actions.ROLL_DICE_ACTION:
            return { ...state, currentRoll: action.diceIndices, status: "ROLLED" };
        case Actions.SELECT_SEVEN_ACTION:
            return { ...state, selectedSeven: action.seven, status: "SEVEN_SELECTED" };
        case Actions.REPLACE_SEVEN_ACTION:
            var desiredFace: VpFace = { type: "Vp", value: action.points };
            return { 
                ...state, 
                status: "READY_TO_BUMP",
                dice: state.dice.set(action.index, { faces: state.dice.get(action.index).faces.set(state.currentRoll[action.index], desiredFace) }) 
            };
        case Actions.PLACE_X_ACTION:
            var newStatus: Status = "READY_TO_BUMP";
            if (Selector.strikes(state) >= 2) {
                newStatus = "GAME_OVER";
            }
            return {
                ...state,
                status: newStatus,
                dice: state.dice.set(action.index, { faces: state.dice.get(action.index).faces.set(state.currentRoll[action.index], X) }) 
            }
        case Actions.PASS_BUMP_VALUE_ACTION:
            return { ...state, currentRoll: undefined, selectedSeven: undefined, status: "BEGIN" };
        case Actions.BUMP_VALUE_ACTION:
            return { 
                ...state, 
                status: "BEGIN",
                currentRoll: undefined, 
                selectedSeven: undefined, 
                dice: state.dice.set(action.index, { faces: state.dice.get(action.index).faces.set(state.currentRoll[action.index], action.face) }) 
            };
        default:
            return state;
    }
}